import { webDataLoading, webDataNotAsked, webDataSuccess, serializedErrorToWebDataError } from "@lvt/web-data";
import { createSlice } from "@reduxjs/toolkit";

import { fetchArchiveCabinets } from "@/api/map/archiveCabinets/archiveCabinets";
import { RootState } from "@/store";
import { ArchiveCabinetState } from "@/store/map/archiveCabinets/types";


const initialState: ArchiveCabinetState = {
    archiveCabinets: webDataNotAsked(),
};

export const archiveCabinetsSlice = createSlice({
    name: "archiveCabinets",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchArchiveCabinets.pending, (state) => {
                state.archiveCabinets = webDataLoading();
            })
            .addCase(fetchArchiveCabinets.fulfilled, (state, action) => {
                state.archiveCabinets = webDataSuccess(action.payload);
            })
            .addCase(fetchArchiveCabinets.rejected, (state, action) => {
                state.archiveCabinets = serializedErrorToWebDataError(action.error);
            });
    },
});

export const archiveCabinetsReducer = archiveCabinetsSlice.reducer;
export const archiveCabinetsSelectors = {
    getArchiveCabinets: (state: RootState) => {
        return state.mapArchiveCabinets.archiveCabinets;
    },
};
